import { useEffect } from 'react';
import { initPlatform } from '@/core/platform';
import { boot, onUnlocked, useSession } from '@/core/session';
import { initSync, syncNow } from '@/core/sync';
import { startAutoLock } from '@/modules/settings/autolock';
import { AppShell } from './AppShell';
import { LockScreen, Splash, Welcome } from './Gate';

initSync();
startAutoLock();
// Oura, Renpho and Trace: pull what's new once the data is open, then every so often.
onUnlocked(() => void import('@/modules/connections/run').then((m) => m.startConnections()));

export function App() {
  const { phase } = useSession();
  useEffect(() => {
    void boot();
    void initPlatform(() => void syncNow());
  }, []);
  if (phase === 'loading') return <Splash />;
  if (phase === 'welcome') return <Welcome />;
  if (phase === 'locked') return <LockScreen />;
  return <AppShell />;
}
